import React from 'react';
import PropTypes from 'prop-types';
import Button from 's2s-button';
import { getIntlText } from '../js/utilities';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';

const NumberListItem = styled.li`
  align-items: center;
  background-color: ${colorGrid.gray2};
  border-bottom: 1px solid ${colorGrid.gray3};
  color: ${colorGrid.gray9};
  display: flex;
  font-size: 12px;
  flex-direction: row;
  justify-content: space-between;
  line-height: 1.33;
  padding: 8px 16px
  cursor: pointer;

  &:hover {
    background-color: ${colorGrid.gray0};
  }
`;

const PreferredNumberIndicator = styled.p`
  align-items: center
  color: ${colorGrid.gray6};
  margin: 0px;
  height: 16px; //height set by design
`;

const PhoneNumber = styled.p`
  margin: 0px;
  height: 16px; //height set by design
`;

const NumberType = styled(PhoneNumber)`
  font-weight: 600;
`;

const NumberList = styled.ul`
  list-style: none;
  margin: 0px;
  padding: 0px;
  max-height: 200px;
  overflow-y: auto;
`;

const NumberSelectionContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  vertical-align: middle;
`;
const NumberSelectionModal = styled.div`
  background-color: ${colorGrid.gray0};
  border: 2px solid ${colorGrid.blue9};
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(33, 37, 41, 0.48);
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin: auto;
  min-height: 132px; // height set by design, includes header: 40px, Instruction: 40px, 1 phone number: 48px, and border: 4px
  min-width: 268px; // set by design
  max-width: 268px; // set by design
  z-index : 1000;
`;

const ModalHeader = styled.div`
  align-items: center;
  background-color: ${colorGrid.blue9};
  color: ${colorGrid.gray0};
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.33;
  letter-spacing: 0.1px;
  font-size: 12px;
  min-height: 40px; //set by design
`;
//ContactNameTitle
const ContactNameTitle = styled.p`
  align-items: center;
  display: flex;
  margin: 0px;
  min-height: 24px; //set by design
  padding: 8px 16px;
`;

const StyledButton = styled(Button)`
  background-color: ${colorGrid.blue9};
  display : flex;
  height : 40px;
  justify-content : center;
  width : 40px;
  padding : 0px;
  margin-right : 4px;

  &:hover {
    background-color : ${colorGrid.blue6};
  }
`;

const NumberListItemLeftArea = styled.div``;

const NumberListItemRightArea = styled(NumberListItemLeftArea)``;

const ModalInstruction = styled.div`
  align-items: center;
  background-color: ${colorGrid.blue6};
  color: ${colorGrid.gray0};
  display: flex;
  font-size: 12px;
  font-weight: 600;
  line-height: 2;
  letter-spacing: 0.1px;
  margin: 0px;
  min-height: 24px; //set by design
  padding: 8px 16px;
`;

const NumberSelection = (props) => {

  const handleNumberSelection = (numberItem) => {
    props.cbHandleNumberSelected(numberItem);
  };

  const renderNumberObject = (numberItem, index) => {

    //if the phone number provided is a number and not a string, make it a string. Else leave it as a string
    const phoneNumber = typeof (numberItem.number) === 'number' ? numberItem.number.toString() : numberItem.number;

    const preferredNumber = (
      <NumberListItemRightArea className="NumberListItemRightArea" >
        <PreferredNumberIndicator className="PreferredNumberIndicator" >
          {getIntlText(props.intl, 'NUMBER-SELECTION-MODAL-PREFERRED', 'Preferred')}
        </PreferredNumberIndicator>
      </NumberListItemRightArea>
    );

    if (props.cbPhoneNumberValidation(numberItem.number)) {
      return (
        <NumberListItem
          className={`numberListItem${index} ${props.className}`}
          key={`i${index}`}
          onClick={() => { handleNumberSelection(numberItem); }}
        >
          <NumberListItemLeftArea className="NumberListItemLeftArea">
            <NumberType className="numberType" >
              {numberItem.type}
            </NumberType>
            <PhoneNumber className="phoneNumber" >
              {phoneNumber}
            </PhoneNumber >
          </NumberListItemLeftArea>
          {numberItem.preferred === true ? preferredNumber : undefined}
        </NumberListItem>
      );
    } else {
      return null;
    }
  };

  const renderNumberList = (numberList) => {
    console.log('NUMBER LIST prop', numberList);
    return (
      <NumberList className="numberList" >
        {numberList.map((numberItem, index) => {
          return renderNumberObject(numberItem, index);
        })
        }
      </NumberList>
    );
  };

  return (
    <NumberSelectionContainer className="NumberSelectionContainer" >
      <NumberSelectionModal className="NumberSelectionModal">
        <ModalHeader className="ModalHeader" >
          <ContactNameTitle className="ContactNameTitle" >
            {props.contactName}
          </ContactNameTitle>
          <StyledButton
            className="closeModalBtn"
            ariaLabel={'Close Number Selection'}
            buttonType="ghost"
            svgFill={colorGrid.gray0}
            svgType="CloseIconSVG"
            cbClick={props.cbCancelNumberSelection}
            isDisabled={false}
          />
        </ModalHeader>
        <ModalInstruction className="ModalInstruction" >
          {props.selectMessageText}
        </ModalInstruction>
        {renderNumberList(props.contactNumberList)}
      </NumberSelectionModal>
    </NumberSelectionContainer>
  );
};


NumberSelection.propTypes = {
  cbCancelNumberSelection: PropTypes.func,
  cbHandleNumberSelected: PropTypes.func,
  cbPhoneNumberValidation: PropTypes.func,
  contactName: PropTypes.string,
  contactNumberList: PropTypes.array,
  selectMessageText: PropTypes.string
};

NumberSelection.defaultProps = {
  cbCancelNumberSelection: () => { },
  cbHandleNumberSelected: () => { },
  cbPhoneNumberValidation: (number) => { return number && number.length >= 10; },
  contactName: 'Contact Name Missing',
  contactNumberList: [],
  selectMessageText: "Select the number to message."
};

export default NumberSelection;
